import { render, staticRenderFns } from "./ServicesTwo.vue?vue&type=template&id=67de3440&"
import script from "./ServicesTwo.vue?vue&type=script&lang=js&"
export * from "./ServicesTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports